import React from 'react';
import { STATUS_COLORS } from '../utils/constants';
import './StatsBar.css';

const STAT_ICONS = {
  Applied: '📤', Screening: '🔍', Interview: '🗣️',
  Assessment: '📝', Offer: '🎉', Accepted: '✅',
  Rejected: '❌', Withdrawn: '↩️', Ghosted: '👻'
};

const StatsBar = ({ stats }) => {
  const { stats: breakdown = [], total = 0 } = stats;
  const statMap = {};
  breakdown.forEach(s => { statMap[s._id] = s.count; });

  const activeCount = (statMap['Applied']||0)+(statMap['Screening']||0)+(statMap['Interview']||0)+(statMap['Assessment']||0);
  const offerCount = (statMap['Offer']||0)+(statMap['Accepted']||0);
  // const rejectedCount = (statMap['Rejected']||0)+(statMap['Ghosted']||0)+(statMap['Withdrawn']||0);
  const successRate = total > 0 ? Math.round((offerCount / total) * 100) : 0;

  return (
    <div className="stats-section">
      <div className="stats-summary">
        <div className="stat-card stat-total">
          <div className="stat-icon-wrap stat-icon-blue">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/></svg>
          </div>
          <span className="stat-number">{total}</span>
          <span className="stat-label">Total Applications</span>
        </div>
        <div className="stat-card stat-active">
          <div className="stat-icon-wrap stat-icon-teal">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          </div>
          <span className="stat-number">{activeCount}</span>
          <span className="stat-label">In Progress</span>
        </div>
        <div className="stat-card stat-offer">
          <div className="stat-icon-wrap stat-icon-green">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>
          </div>
          <span className="stat-number">{offerCount}</span>
          <span className="stat-label">Offers</span>
        </div>
        <div className="stat-card stat-rate">
          <div className="stat-icon-wrap stat-icon-amber">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/></svg>
          </div>
          <span className="stat-number">{successRate}%</span>
          <span className="stat-label">Offer Rate</span>
        </div>
      </div>

      {breakdown.length > 0 && (
        <div className="stats-breakdown">
          {breakdown.map(s => {
            const c = STATUS_COLORS[s._id] || {};
            return (
              <div key={s._id} className="stat-badge"
                style={{ background: c.bg, color: c.text, border: `1px solid ${c.border}` }}>
                <span>{STAT_ICONS[s._id] || '·'}</span>
                <span>{s._id}</span>
                <span className="stat-badge-count">{s.count}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default StatsBar;
